import React, { useContext } from 'react';

const StampDataContext = React.createContext();
export const StampDataProvider = StampDataContext.Provider;
export const StampDataConsumer = StampDataContext.Consumer;

export const initialStampData = {
  stampCollection: null,
  userStamps: [],
};

export const withStampData = (Component) => {
  return (props) => (
    <StampDataConsumer>
      {({ stampCollection, setStampCollection, userStamps, setUserStamps }) => (
        <Component
          stampCollection={stampCollection}
          setStampCollection={setStampCollection}
          userStamps={userStamps}
          setUserStamps={setUserStamps}
          {...props}
        />
      )}
    </StampDataConsumer>
  );
};

export const useStampData = () => useContext(StampDataContext);

export default StampDataContext;
